// extracted by mini-css-extract-plugin
export default {"chevron":"concepts_chevron__-jmEg","expanded":"concepts_expanded__wPA1V"};